export class JobProgressStepBucketDataBackupDataCoverage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backableObjects",
            "baseName": "backableObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backableBytes",
            "baseName": "backableBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backedUpObjects",
            "baseName": "backedUpObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backedUpBytes",
            "baseName": "backedUpBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "notBackedUp",
            "baseName": "notBackedUp",
            "type": "Array<JobProgressStepBucketDataBackupDataCoverageNotBackedUpInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepBucketDataBackupDataCoverage.attributeTypeMap;
    }
    constructor() {
    }
}
